export const LIVE_POSTER_URL =
    "https://assets.bwbx.io/images/izrptLrH5AWw/v1/720x405.jpg";

export const FALLBACK_IMAGE =
    "https://assets.bwbx.io/s3/multimedia/vh/_next/static/media/BBG_LogoRefresh.66e55f42.png";
